import Column from 'components/Column'
import { selectors } from 'data'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import isEmbedded from 'utils/isEmbedded'

import Footer from './Footer'
import Header from './Header'
import ScreenObserver from './ScreenObserver'

const Wrapper = styled(Column)`
  width: 100%;
  min-height: 100%;
`

const Main = styled(Column)`
  width: 100%;
  flex-basis: 0%;
  flex-grow: 1;
`

type Props = { children: React.ReactNode }

const Layout = ({ children }: Props) => {
  const user = useSelector(selectors.auth.getUser)

  const showDisclaimer = !user || user?.address?.country === 'GB'

  return (
    <>
      <ScreenObserver />
      <Wrapper>
        <Main>
          {!isEmbedded() && <Header showDisclaimer={showDisclaimer} />}
          {children}
        </Main>

        {!isEmbedded() && <Footer showDisclaimer={showDisclaimer} />}
      </Wrapper>
    </>
  )
}

export default Layout
